import React, { useEffect, useState } from 'react';
import { fetchCountryCount, fetchVitalStats } from '../services/api'; 
import Header from '../components/Header';

const DonorStats = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const rowsPerPage = 100;
  const [vitalStatsData, setvitalStatsData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadAll = async () => {
      try {
        setIsLoading(true);
        const [vitalResponse, countryCounts] = await Promise.all([
          fetchVitalStats(),
          fetchCountryCount()
        ]);
        setvitalStatsData(vitalResponse[0]);
        const sorted = countryCounts.sort((a, b) => b.count - a.count);
        setData(sorted);
      } finally {
        setIsLoading(false);
      }
    };
    loadAll();
  }, []);

  const paginatedData = data.slice(
    currentPage * rowsPerPage,
    (currentPage + 1) * rowsPerPage
  );

  const totalPages = Math.ceil(data.length / rowsPerPage);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-lg text-gray-600">Loading Donor Stats...</div>
      </div>
    );
  }

  return (
    <div>
    <Header pageTitle="Vital Stats, Historical" />
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">

        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">Activity Data</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <p className="text-sm text-gray-600 mb-2">Total Published Pieces</p>
              <p className="text-2xl font-bold text-gray-800">{vitalStatsData.total_published_pieces?.toLocaleString()}</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <p className="text-sm text-gray-600 mb-2">Total Peer Reviews</p>
              <p className="text-2xl font-bold text-gray-800">{vitalStatsData.total_peer_reviews?.toLocaleString()}</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <p className="text-sm text-gray-600 mb-2">Total Published Comments</p>
              <p className="text-2xl font-bold text-gray-800">{vitalStatsData.total_published_comments?.toLocaleString()}</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <p className="text-sm text-gray-600 mb-2">Total Likes</p>
              <p className="text-2xl font-bold text-gray-800">{vitalStatsData.total_likes?.toLocaleString()}</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <p className="text-sm text-gray-600 mb-2">Total Reads</p>
              <p className="text-2xl font-bold text-gray-800">{vitalStatsData.total_reads?.toLocaleString()}</p>
            </div>
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">User Data</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <p className="text-sm text-gray-600 mb-2">Total Users</p>
              <p className="text-2xl font-bold text-gray-800">{vitalStatsData.total_users?.toLocaleString()}</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <p className="text-sm text-gray-600 mb-2">Total YWs (Excl. Alumni)</p>
              <p className="text-2xl font-bold text-gray-800">{vitalStatsData.yw_users?.toLocaleString()}</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <p className="text-sm text-gray-600 mb-2">Total Educators</p>
              <p className="text-2xl font-bold text-gray-800">{vitalStatsData.ed_users?.toLocaleString()}</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <p className="text-sm text-gray-600 mb-2"># Unique Countries, Historical</p>
              <p className="text-2xl font-bold text-gray-800">{vitalStatsData.yw_countries_historical?.toLocaleString()}</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <p className="text-sm text-gray-600 mb-2"># Unique Countries, 2023</p>
              <p className="text-2xl font-bold text-gray-800">{vitalStatsData.yw_countries_2023?.toLocaleString()}</p>
            </div>
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">Comp Data</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <p className="text-sm text-gray-600 mb-2">Total Competition #</p>
              <p className="text-2xl font-bold text-gray-800">{vitalStatsData.total_competitions?.toLocaleString()}</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <p className="text-sm text-gray-600 mb-2">Total Competition Entries</p>
              <p className="text-2xl font-bold text-gray-800">{vitalStatsData.total_entries?.toLocaleString()}</p>
            </div>
          </div>
        </div>

        <h2 className="text-3xl font-bold text-gray-800 mb-6"># of User by Country, Historical</h2>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <div className="max-h-96 overflow-y-auto">
            <table className="w-full">
              <thead className="bg-gray-50 sticky top-0 z-10">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">#</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Country</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Count</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {paginatedData.map((item, index) => (
                  <tr key={item.country} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{currentPage * rowsPerPage + index + 1}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.country}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.count.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="flex justify-between items-center mt-6 text-sm text-gray-600">
          <span>
            {currentPage * rowsPerPage + 1} -{' '}
            {Math.min((currentPage + 1) * rowsPerPage, data.length)} / {data.length}
          </span>
          <div className="flex space-x-2">
            <button 
              onClick={() => setCurrentPage(p => Math.max(p - 1, 0))} 
              disabled={currentPage === 0}
              className="px-3 py-1 border border-gray-300 rounded text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              &lt;
            </button>
            <button
              onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages - 1))}
              disabled={currentPage === totalPages - 1}
              className="px-3 py-1 border border-gray-300 rounded text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              &gt;
            </button>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default DonorStats;
